import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/step_check.png'
import _imports_1 from '@/assets/images/certification_icon.png'


const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "login_wrap" }




export default /*@__PURE__*/_defineComponent({
  __name: 'CertificateRegistrationView',
  emits: ["setJoin"],
  setup(__props, { emit: __emit }) {

const emit = __emit;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"page_header\" data-v-47d9e84e>회원가입</div><div class=\"page_header_line\" data-v-47d9e84e></div><div class=\"steps\" data-v-47d9e84e><div class=\"step active\" data-v-47d9e84e><div class=\"step_circle\" data-v-47d9e84e><img src=\"" + _imports_0 + "\" data-v-47d9e84e><div class=\"step_label\" data-v-47d9e84e>약관동의</div></div></div><div class=\"step active\" data-v-47d9e84e><div class=\"step_line\" data-v-47d9e84e></div><div class=\"step_circle\" data-v-47d9e84e><img src=\"" + _imports_0 + "\" data-v-47d9e84e><div class=\"step_label\" data-v-47d9e84e>정보입력</div></div></div><div class=\"step active\" data-v-47d9e84e><div class=\"step_line\" data-v-47d9e84e></div><div class=\"step_circle\" data-v-47d9e84e><div class=\"step_label\" data-v-47d9e84e>인증서등록</div></div></div><div class=\"step\" data-v-47d9e84e><div class=\"step_line\" data-v-47d9e84e></div><div class=\"step_circle\" data-v-47d9e84e><div class=\"step_label\" data-v-47d9e84e>심사 후 승인</div></div></div></div><div class=\"description\" data-v-47d9e84e> 파트너비드 플러스를 이용하시기 위해서는 <span data-v-47d9e84e>사업자 범용 인증서 등록</span>이 필요합니다.<br data-v-47d9e84e> 아래 버튼을 클릭하여 등록해주세요. </div>", 4)),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", null, [
        _createElementVNode("img", {
          src: _imports_1,
          class: "image_div"
        })
      ], -1)),
      _createElementVNode("div", {
        class: "login_btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('setJoin')))
      }, "사업자 범용 인증서 등록")
    ])
  ]))
}
}

})